export default __webpack_public_path__ + "static/media/A9202844.fd858beb.jpg";